import ajax from '@/utils/ajax';

export const head = '/web';
// const applets = '/applets';

// 获取ai应用列表
export const getAiBotList = () => ajax(`${head}/v1/ai-app/list`, '', 'GET');

// 获取当前ai信息
export const getAiInfo = (appId) => ajax(`${head}/v1/ai-app/${appId}`, '', 'GET');

// 获取会话id sessionId
export const getAiSessionId = (appId) => ajax(`${head}/v1/ai-session/info?appId=${appId}`, '', 'GET');

// 开始会话连接
export const openAiConnect = (data) => ajax('/tool/v1/ai-sse/connect', data, 'post', { responseType: 'stream' });

// 停止回答
export const stopAiConnect = (connectId) => ajax(`${head}/v1/ai-sse/stop-stream/${connectId}`, '', 'GET');

export const getHistoryAiInfo = (sessionId, pageNum, pageSize) => ajax(`${head}/v1/ai-session/history/session-record?sessionId=${sessionId}&pageNum=${pageNum}&pageSize=${pageSize}`, '', 'GET');
